export default "__VITE_ASSET__b62b6ef6__"